import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  CardTitle,
  Row
} from "reactstrap";
import DialogContent from '@material-ui/core/DialogContent';
import { appUrl } from '../../config';
import { DialogTitle, Dialog, DialogActions } from '@material-ui/core';
import { Link } from "react-router-dom";
// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
var md5 = require('md5');

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      user: '',
      password: '',
      firstFocus: false,
      lastFocus: false,
      msgdiag: "",
      open: false,
      open1: false,
      usermail: ""
    }
  }
  handleChange = name => event => {
    this.setState({ [name]: event.target.value })
  };

  handleClickOpen = (msgdiag) => {
    this.setState({ open: true, msgdiag: msgdiag });
  }

  handleClose = () => {
    this.setState({ open: false, msgdiag: "" });
  }

  handleClickOpen1 = () => {
    this.setState({ open1: true });
  }

  handleClose1 = () => {
    this.setState({ open1: false });
  }
  handleClick = (event, user, password) => {
    console.log("handleClick", user, password, appUrl + '/login')
    var pass = md5(password)
    fetch(appUrl + '/login', {
      method: 'post',
      body: JSON.stringify({
        mail: user,
        password: pass,
        open: false
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log(data)
          if (data.success) {
            console.log(data)
            this.props.onChange("user", { name: data.user.name, mail: data.user.mail, profile: data.user.profile, cc: data.user.cc, emp: data.user.emp });
            this.props.onChange("view", "index");
            this.props.onChange("userstatus", true);
            if (data.user.profile == "admin") {
              this.props.onChange("admin", true);
            }
          }
        } else {
          this.handleClickOpen("Usuario o contraseña no coinciden")
        }
      });
  }

  handleClick2 = (event, user, password) => {
    console.log("handleClick2", user, password, appUrl + '/login')
    fetch(appUrl + '/login', {
      method: 'post',
      body: JSON.stringify({
        mail: user,
        password: password,
        open: false
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log(data)
          if (data.success) {
            console.log(data)
            this.props.onChange("user", { name: data.name, mail: data.mail, profile: data.profile, emp: data.emp, cc: data.cc });
            this.props.onChange("view", "index");
            this.props.onChange("userstatus", true);
            if (data.profile == "admin") {
              this.props.onChange("admin", true);
            }
          }
        } else {
          this.handleClickOpen("Usuario o contraseña no coinciden")
        }
      });
  }

  handleSave = () => {
    console.log("handleSave")
    var random = Math.random();
    var value = md5(random)
    console.log("value", random, value)
    console.log(this.state.usermail)
    var user = {
      mail: this.state.usermail,
      code: value,
      status: true
    }
    fetch(appUrl + '/recoverypass', {
      method: 'post',
      body: JSON.stringify({
        user: user,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log(data)

          this.setState({ open: true, msgdiag: data.message, usermail: "" })
          this.handleClose1()

        } else {
          this.setState({ open: true, msgdiag: data.message })
        }
      });
  }
  render() {

    return (
      <>
        <ExamplesNavbar onChange={this.props.onChange} productselected={this.props.productselected} products={this.props.products} user={this.props.user} userstatus={this.props.userstatus} />
        <div className="page-header clear-filter" filter-color="blue">
          <div
            className="page-header-image"
            style={{
              backgroundImage: "url(" + require("assets/img/header.jpg") + ")"
            }}
          ></div>
          <div className="content">
            <Container>
              <Col className="ml-auto mr-auto" md="4">
                <Card className="card-login card-plain">
                  <Form action="" className="form" method="">
                    <CardHeader className="text-center">
                      <div >
                        <img
                          alt="..."
                          src={require("assets/img/logosinfondo.png")}
                        ></img>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <h1 style={{ fontSize: "20px" }}>Ingresa con tu cuenta Premium</h1>

                      <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons users_circle-08"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Correo"
                          type="text"
                          value={this.state.user || ''}
                          onChange={this.handleChange('user')}
                          onFocus={() => this.setState({ firstFocus: true })}
                          onBlur={() => this.setState({ firstFocus: false })}
                          style={{ fontSize: "15px", }}
                        ></Input>
                      </InputGroup>
                      <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.lastFocus ? " input-group-focus" : "")
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons text_caps-small"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input

                          placeholder="Contraseña"
                          type="password"
                          value={this.state.password || ''}
                          onChange={this.handleChange('password')}
                          onFocus={() => this.setState({ lastFocus: true })}
                          onBlur={() => this.setState({ lastFocus: true })}
                          style={{ fontSize: "15px", }}

                        ></Input>
                      </InputGroup>
                      <Button
                        block
                        className="btn-round"
                        color="info"
                        onClick={event => this.handleClick(event, this.state.user, this.state.password)}
                        size="lg"
                      >
                        Entrar
                    </Button>
                      <Button
                        className="btn-round"
                        color="white"
                        onClick={this.handleClickOpen1}
                        outline
                      >
                        Crear/Olvidé mi contraseña
                    </Button>
                    </CardBody>

                  </Form>
                </Card>
              </Col>

            </Container>
          </div>
        </div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title"><h6 style={{ color: '#676768' }}>{this.state.msgdiag}</h6></DialogTitle>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Ok
                </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.open1}
          onClose={this.handleClose1}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ color: 'black' }}
        >
          <DialogTitle id="alert-dialog-title"><h5 style={{ color: '#676768' }}>Recuperar contraseña</h5></DialogTitle>
          <DialogContent  >
            <Form action="" className="form" method="">
              <InputGroup >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons ui-1_email-85"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.usermail || ''}
                  onChange={this.handleChange('usermail')} placeholder="Correo"
                  type="text"
                ></Input>
              </InputGroup>
            </Form>
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleClose1} color="primary" autoFocus>
              Cancelar
                </Button>
            {this.state.correorec !== "" ?
              <Button onClick={this.handleSave} color="primary" autoFocus>
                Enviar
              </Button>
              : null
            }
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default LoginPage;